/**
 * @file jobBookmarkPlacement.ts
 *
 * @fileoverview Exports job bookmark possible placements enum.
 */
export enum JobBookmarkPlacement {
  JOB_TEASER = 'job teaser',
  JOB_DETAIL = 'job detail',
}

export default JobBookmarkPlacement;
